import { useState } from "react";
import { NotificationManager } from "react-notifications";
import { getErrorFromResponse } from "../../../../../../../utility/utils";
import { useFiltrosReporteProduccion } from "../../hooks/useFiltrosReporteProduccion";
import { ResumenConsumoProdApi } from "../api/ResumenConsumoProdApi";

const STORAGE_KEY = "reporte_resumen_consumo_prod";

// El rango de fechas y el padre PT son obligatorios, así que el reporte no se
// consulta solo: la tabla queda vacía hasta que se presiona Filtrar
export const useResumenConsumoProd = () => {
    const { getResumenConsumo, descargarResumenConsumoExcel, cargando } =
        ResumenConsumoProdApi();

    const [resumen, setResumen] = useState(null);
    // el error se muestra también junto a la tabla porque enumera los turnos o
    // bultos que tienen el DRC pendiente y la notificación se va muy rápido
    const [mensajeError, setMensajeError] = useState("");
    const ConsultarResumen = async (params) => {
        try {
            setMensajeError("");

            setResumen(await getResumenConsumo(params));
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener el resumen de consumo",
            );
            NotificationManager.error(errorMsg, "Error", 3000);

            setResumen(null);
            setMensajeError(errorMsg);
        }
    };

    const DescargarExcel = async (params) => {
        try {
            await descargarResumenConsumoExcel(params);
        } catch (error) {
            NotificationManager.error(
                getErrorFromResponse(
                    error,
                    "Error al exportar el resumen de consumo",
                ),
                "Error",
                3000,
            );
        }
    };

    const filtros = useFiltrosReporteProduccion({
        storageKey: STORAGE_KEY,
        onConsultar: ConsultarResumen,
        onDescargar: DescargarExcel,
    });

    return {
        ...filtros,

        resumen,
        mensajeError,
        cargando,
    };
};
